import Cookies from 'universal-cookie';

const cookies = new Cookies();

const sma = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
]
const status = [
  { value: "DOCUMENTED", label: "Documented" },
  { value: "RESOLVED", label: "Resolved" },
  { value: "TODO", label: "To-do" },
]
const role = [
  { value: "PII Controller", label: "PII Controller" },
  { value: "Joint PII Controller", label: "Joint PII Controller" },
  { value: "PII Processor", label: "PII Processor" },
]
const categoryInd = [
  { value: "Employees", label: "Employees" },
  { value: "Potential Employees", label: "Potential Employees" },
  { value: "Customer", label: "Customer" },
  { value: "Suppliers", label: "Suppliers" },
  { value: "Contractors", label: "Contractors" },
  { value: "Potential Customer", label: "Potential Customer" },
]
const categoryPersonal = [
  { value: "Employment Details", label: "Employment Details" },
  { value: "Health Details", label: "Health Details" },
  { value: "Contact Details", label: "Contact Details" },
  { value: "Financial Details", label: "Financial Details" },
  { value: "Lifestyle Information", label: "Lifestyle Information" },
  { value: "Potential Customer", label: "Potential Customer" },
]
const law = [
  { value: "Consent", label: "Consent" },
  { value: "Cotractual Obligation", label: "Cotractual Obligation" },
  { value: "Legal Obligation", label: "Legal Obligation" },
  { value: "Vital Interest", label: "Vital Interest" },
  { value: "Public Interest", label: "Public Interest" },
  { value: "Legetimate Interest", label: "Legetimate Interest" },
]
const transferSafeguard = [
  { value: "Adequacy Decesion", label: "Adequacy Decesion" },
  { value: "Binding Corporate Rules", label: "Binding Corporate Rules" },
  { value: "Standard Contractual Clauses", label: "Standard Contractual Clauses" },
  { value: "Approved Codes of Conduct", label: "Approved Codes of Conduct" },
  { value: "Not Known", label: "Not Known" },
  { value: "Not Applicable", label: "Not Applicable" },
]
const externalRecep = [
  { value: "Data Processor", label: "Data Processor" },
  { value: "Government Body", label: "Government Body" },
  { value: "Other Stakeholder", label: "Other Stakeholder" },
  { value: "Supplier", label: "Supplier" },
  { value: "Not Applicable", label: "Not Applicable" },
  { value: "Data Controller", label: "Data Controller" },
]
const security = [
  { value: "Pseudonymization", label: "Pseudonymization" },
  { value: "Access Control", label: "Access Control" },
  { value: "Encryption", label: "Encryption" },
  { value: "Deidentification", label: "Deidentification" },
  { value: "Firewalls", label: "Firewalls" },
  { value: "Password Protection", label: "Password Protection" },
  { value: "MFA", label: "MFA" },
]

const criminalData = [
  { value: "Not Applicable", label: "Not Applicable" },
  { value: "Racial", label: "Racial" },
  { value: "Ethnic Origin", label: "Ethnic Origin" },
  { value: "Political Opinions", label: "Political Opinions" },
  { value: "Religious Belief", label: "Religious Belief" },
  { value: "Philosophical Beliefs", label: "Philosophical Beliefs" },
  { value: "Trade Union Membership", label: "Trade Union Membership" },
  { value: "Genetic Data", label: "Genetic Data" },
  { value: "Biometric Data", label: "Biometric Data" },
  { value: "Health Data", label: "Health Data" },
  { value: "Data Concerning natural person's sex life ", label: "Data Concerning natural person's sex life " },
  { value: "Sexual Orientation", label: "Sexual Orientation" },
  { value: "Other SC", label: "Other SC" },
  { value: "Criminal Data", label: "Criminal Data" },
]
const business = [
  { value: "Finance", label: "Finance" },
  { value: "Sales & Marketing", label: "Sales & Marketing" },
  { value: "Operations", label: "Operations" },
  { value: "Human Resources", label: "Human Resources" },
  { value: "Information Technology", label: "Information Technology" },
  { value: "Legal", label: "Legal" },
  { value: "Executive Office", label: "Executive Office" },
]

const purpose = [
  { value: "Customer Obligation", label: "Customer Obligation" },
  { value: "Employment", label: "Employment" },
  { value: "Supplier Management", label: "Supplier Management" },
  { value: "Marketing & Demang gen", label: "Marketing & Demang gen" },
  { value: "Research & Analysis", label: "Research & Analysis" },
  { value: "Education & Training", label: "Education & Training" },
  { value: "Payroll", label: "Payroll" },
  { value: "Other Purpose", label: "Other Purpose" },
]

export const storeCookies = (name, value) => {
  cookies.set(name, JSON.stringify(value),
    { path: "/" })

}

export const getCookies = (name) => {
  return cookies.get(name)

}
export const removeCookies = (name) => {
  return cookies.remove(name)

}

export const headerTable = (type) => {
  if (type === "TermsOfUse") {
    const table = [
      "Language code", "Terms of use date", "Terms of use url", "Created"
    ]
    return table
  }
  else if (type === "PrivacyPolicies") {
    const table = [
      "Language code", "Privacy policy date", "Privacy policy url", "Created"
    ]
    return table
  }
  else if (type === "Projects") {
    const table = [
      "Name", "Dp handle", "Email From", "Created"
    ]
    return table
  }
  else if (type === "ROPA") {
    const table = [
      "ID", "Status", "Business Function", "Purpose of Processing", "Our Role", "Tenant Role", "Category of Individual", "Category of Personal Data", "Lawful Basis", "International Data Transfer", "International Transfer Safeguards", "External Recipients With Access", "Retention Schedule Defined", "Technical & Organisational Security Measures", "Special Categories or Criminal Data", 
      //"Assigned To",
      "Projects", "Data Types", "Review Date"
    ]
    return table
  }
  else if (type === "PrivacyRequests") {
    const table = [
      "DOR", "Name", "Email", "Message Content", "Request Validated", "Request Responded", "Response Date", "Status Request Action",
    ]
    return table
  }
  else if (type === "RequestTypes") {
    const table = [
      "Name", "Trigger Url", "Trigger Method", "Created"
    ]
    return table
  }
  else if (type === "users") {
    const table = [
      "Name", "Email", "Email domains", "Created"
    ]
    return table
  }
  else if (type === "DataSubjectTypes") {
    const table = [
      "Name", "Project", "Tenant", "Created"
    ]
    return table
  }
  else {
    const table = [
      "Name", "Dp handle", "Email domains", "Created"
    ]
    return table
  }
}

export const headerTableBody = () => {
  const obj = {}
  return obj
}

export const TableBodyClass = (apilink) => {
  if (apilink === "ropa") {
    const obj = [{ name: "id", type: "string", minWidth: 100 },
    // { name: "name", type: "string", minWidth: 100 },
    {
      placeholder: "Select status here",
      label: "Status", name: "status", type: "select", minWidth: 100, options: status,
      isMulti: false
    },
    {
      placeholder: "Select business here",
      label: "Business function", name: "business_function", type: "select", minWidth: 100, options: business
    },
    {
      placeholder: "Select purpose here",
      label: "Purpose of processing", name: "purpose", type: "select", minWidth: 100, options: purpose
    },
    {
      placeholder: "Select role here",
      label: "R2's role", name: "r2_role", type: "select", minWidth: 100, options: role
    },
    {
      placeholder: "Select Tenant role here",
      label: "Tenant role", name: "tenant_role", type: "select", minWidth: 100, options: role
    },
    {
      placeholder: "Select category of Individual here",
      label: "Category of Individual", name: "individual_categories", type: "select", minWidth: 100, options: categoryInd
    },
    {
      placeholder: "Select category of personal here",
      label: "Category of personal data", name: "personal_data_categories", type: "select", minWidth: 125, options: categoryPersonal
    },
    {
      placeholder: "Select lawful basis here",
      label: "Lawful basis", name: "legal_reason", type: "select", minWidth: 100, options: law
    },
    {
      placeholder: "Select International data transfer here",
      label: "International data transfer", name: "allow_international_data_transfers", type: "select", minWidth: 100, options: sma,
      isMulti: false
    },
    {
      placeholder: "Select International transfer safeguards here",
      label: "International transfer safeguards", name: "international_data_transfer_safeguards", type: "select", minWidth: 100, options: transferSafeguard
    },
    {
      placeholder: "Select External recipients with e here",
      label: "External recipients with access", name: "external_recipients_with_access", type: "select", minWidth: 100, options: externalRecep
    },
    {
      placeholder: "Select Retention schedule defined here",
      label: "Retention schedule defined", name: "is_retention_schedule_defined", type: "select", minWidth: 100, options: sma,
      isMulti: false
    },
    {
      placeholder: "Select Technical & organizational security measures here",
      label: "Technical & organizational security measures", name: "security_measures", type: "select", minWidth: 100, options: security
    },
    {
      placeholder: "Select Special category or criminal data here",
      label: "Special category or criminal data", name: "criminal_data_categories", type: "select", minWidth: 100, options: criminalData
    },
    { name: "review_date", type: "date", minWidth: 100, },

    ]
    return obj
  }
  const obj = [{ name: "created_at", type: "date", minWidth: 150 },
  { name: "first_name", type: "string", minWidth: 100 },
  { name: "email_address", type: "string", minWidth: 100 },
  { name: "description", type: "string", minWidth: 500 },
  { name: "request_validated", type: "select", minWidth: 100, options: sma },
  { name: "request_responded", type: "select", minWidth: 100, options: sma },
  { name: "response_date", type: "date", minWidth: 125 },
  { name: "status", type: "select", minWidth: 100, options: status },]
  return obj
}

export const createClient = (type) => {
  if (type === "Clients" || type === "Tenants") {
    const obj = [
      { name: "name", title: "Name" },
      { name: "dp_handle", title: "Dp Handle" },
      { name: "email_domains", title: "Email Domains" },
      { name: "has_msa", title: "Has msa", type: "select" },

    ]
    return obj
  }
  else if (type === "Projects") {
    const obj = [
      { name: "name", title: "Name" },
      { name: "dp_handle", title: "Dp Handle" },
      { name: "start_date", title: "Start date", type: "date" },
      { name: "end_date", title: "End date", type: "date" },
      { name: "email_from", title: "Email from", type: "email" },
      { name: "email_cc", title: "Email cc", type: "email" },
      { name: "msa_signed_on", title: "MSA signed on", type: "date" },
      { name: "contract_value", title: "Contract value", type: "number" },
    ]
    return obj
  }
  else if (type === "ROPA") {
    const obj = [
      { name: "name", title: "Name" },
      { name: "business_function", title: "Business Function" },
      { name: "purpose", title: "Purpose" },
      { name: "tenant_role", title: "Tenant Role" },
      { name: "r2_role", title: "R2 Role" },
      { name: "individual_categories", title: "Individual Categories" },
      { name: "personal_data_categories", title: "Personal Data Categories" },
      // { name: "project_id", title: "Project" },
    ]
    return obj
  }
  else if (type === "Data Subject Types") {
    const obj = [
      { name: "name", title: "Name" },
      // { name: "dp_handle", title: "Dp Handle" },
      // { name: "email_domains", title: "Email domains" },
      // { name: "project_id", title: "Project", type: "select", api: true },
      // { name: "tenant_id", title: "Tenant", type: "select", api: true },
      // { name: "has_msa", title: "Has msa", type: "select" },


    ]
    return obj
  }
  else if (type === "Request Types") {
    const obj = [
      { name: "name", title: "Name" },
      { name: "trigger_api_url", title: "Trigger api url" },
      { name: "trigger_api_method", title: "Trigger api method" },
      { name: "trigger_api_params", title: "Trigger api params" },
      // { name: "project_id", title: "Project", type: "select", api: true },


    ]
    return obj
  }
  else if (type === "Privacy Policies") {
    const obj = [
      { name: "privacy_policy_text", title: "Privacy policy text" },
      { name: "privacy_policy_url", title: "Privacy policy url" },
      { name: "language_code", title: "Language code" },
      { name: "privacy_policy_date", title: "Privacy policy date", type: "date" },
      // { name: "project_id", title: "Project", type: "select", api: true },
      { name: "privacy_policy_version", title: "Version", type: "number" }


    ]
    return obj
  }
  else if (type === "Terms Of Use") {
    const obj = [
      { name: "terms_of_use_text", title: "Terms of use text" },
      { name: "terms_of_use_url", title: "Terms of use url" },
      { name: "language_code", title: "Language code" },
      { name: "terms_of_use_date", title: "Terms of use date", type: "date" },
      // { name: "project_id", title: "Project", type: "select", api: true },
      { name: "terms_of_use_version", title: "Version", type: "number" }


    ]
    return obj
  }
  else if (type === "Users") {
    const obj = [
      { name: "name", title: "Name", disable: true },
      { name: "email_address", title: "Email address" },
      { name: "tenant_id", title: "Tenant", type: "select", api: true },



    ]
    return obj
  }
  else if (type === "DSAR Requests") {
    const obj = [
      { name: "created_at", title: "DOR", type: "date", disable: true },
      { name: "first_name", title: "Name", disable: true },
      { name: "email_address", title: "Email", disable: true },
      { name: "phone_number", title: "Phone Number", disable: true },
      { name: "description", title: "Description", disable: true },
      { name: "request_validated", title: "Request validated", type: "select", options: sma },
      { name: "request_responded", title: "Request responded", type: "select", options: sma },
      { name: "response_date", title: "Response Date", type: "date", disable: false },
      { name: "status", title: "Action Status", type: "select", options: status },
    ]
    return obj
  }
  else {
    const obj = [
      { name: "name", title: "Name" },

    ]
    return obj
  }
}